import React from 'react';

/**
 * 상세 패널용 2열 그리드. 한 줄에 2개 항목 + 가운데 | 구분자로
 * 양쪽 값이 서로 다른 항목임을 직관적으로 표시합니다.
 */
function DetailGrid({ children, className = '' }) {
  const arr = React.Children.toArray(children);
  const rows = [];

  for (let i = 0; i < arr.length; i += 2) {
    rows.push(
      <React.Fragment key={i}>
        {arr[i]}
        {arr[i + 1] ? (
          <>
            <div className="flex items-center justify-center shrink-0 text-[#d0d0d0] text-[14px] font-medium select-none" aria-hidden>
              |
            </div>
            {arr[i + 1]}
          </>
        ) : null}
      </React.Fragment>
    );
  }

  return (
    <div
      className={`grid gap-x-4 gap-y-[1.5rem] ${className}`}
      style={{ gridTemplateColumns: '1fr auto 1fr' }}
    >
      {rows}
    </div>
  );
}

export default DetailGrid;
